import React, { useState } from "react"
import { Card, Col } from "react-bootstrap"

import { DashBoardPieCharts } from "../../Shared/Dashboard";
import { Common, SpecifyPieChartName } from "../../../helper";
import { CommonModal } from "./CommonModal";

const Demographics = (props) => {
  const { keyName, Items, isBackGround, mainIndex } = props;
  const [showModal, setShowModal] = useState(false);
  const [isvalue, setValue] = useState();

  const calculateSum = (piechart) => {
    return piechart.reduce((sum, entry) => sum + entry.value, 0);
  };

  const styles = {
    demographyMain: {
      background: "none",
    },
    mainDiv: {
      background: "var(--white-color)",
      minWidth: isBackGround ? "350px" : ""
    },
    pieMainDiv: {
      display: "flex", flexWrap: "wrap", justifyContent: "space-around"
    },
    pieSecondaryDiv: {
      display: "flex", flexDirection: "column", alignItems: "center", minWidth: "200px", padding: "10px"
    },
    chartText: {
      fontWeight: "bold", fontSize: "16px"
    },
    noPupilDiv: {
      display: "flex", alignItems: "center", justifyContent: "center" 
    },
    button: {
      background: "none", cursor: "pointer"
    }
  }

  return (
    <Card className="d-flex dashBoardDemographyMain" style={styles.demographyMain} >
      <div className="abc">
        <Col className="demographyMain" style={styles.mainDiv} >
          <div className="demographyTitle">{`${SpecifyPieChartName(keyName)} (${Items?.totalCount})`}</div>
          {Items?.totalCount != 0 ? <div style={styles.pieMainDiv}>
            {
              Object.entries(Items).map(([key, value], index) => {
                return (key !== "totalCount" && <div key={index} style={styles.pieSecondaryDiv}>
                  <span style={styles.chartText}>{`${SpecifyPieChartName(key)} (${value.totalCount})`}</span>
                  {calculateSum(value.piechart) > 0 ? (
                    <button onClick={() => { setValue(value); setShowModal(true); }} style={styles.button}>
                      <DashBoardPieCharts item={value.piechart} mainIndex={mainIndex} isBackGround={isBackGround} />
                    </button>
                  ) : (
                    <h6>{Common.NoPupils}</h6>
                  )}
                </div>)
              })
            }
          </div> : <div style={styles.noPupilDiv}><h5>{Common.NoPupils}</h5></div>}
        </Col>
      </div>
      <CommonModal showModal={showModal} value={isvalue?.piechart} setShowModal={setShowModal} />
    </Card >
  )
}

export { Demographics }
